import '@webcomponents/scoped-custom-element-registry';
import 'element-internals-polyfill';
import { AutoLoader } from '@cigna/dcws_leaf-web-components/utilities/autoloader.js';
import { registerIconSet } from '@cigna/dcws_leaf-web-components/utilities/icon-library.js';
import { GenericContextProvider as ContextProvider } from '@cigna/dcws_leaf-web-components/utilities/context/generic-provider.js';
import '@cigna/dcws_leaf-web-components/utilities/translations/es.js';
import { ContextRoot } from '@lit-labs/context';
import * as contexts from './apps/contexts.js';
import { initialize as initURLSelects } from './apps/url-select-form/service.js';
import { CampaignsService } from './apps/campaigns/service.js';
import { personalizeContent } from './apps/personalized-content/service.js';
import { components } from './components.js';
import { environment } from './environments/environment.js';
import { fixExternalLinks } from './utils/fix-links.js';
import { initI18n } from './utils/i18n.js';
import { handleEloquaForms } from './utils/forms.js';
import { queryShadowRoot } from './utils/query-shadow-root.js';
import { updateDynamicLinks } from './apps/campaigns/link-service.js';
import { setupClickTracking, createImpression } from './analytics/index.js';

// import { waitFor } from './utils/wait.js';

// Bootstrap the application
registerIconSet('logos', (name: string) => `/static/svgs/logos/${name}-logo.svg`);
registerIconSet('chc', (name: string) => `/static/svgs/chc/${name}.svg`);

personalizeContent(document);

const autoLoader = new AutoLoader(components, { logger: environment.logger });
if (import.meta.env.MODE === 'localdev') {
  autoLoader.components.set('example-element', {
    register() {
      return import('./apps/i18n-example/example.js');
    },
  });
}
autoLoader.discover(document.body);

fixExternalLinks();
handleEloquaForms(environment.flags.enableEloquaTestEmails, environment.logger);
initURLSelects();

// Provide config, functions, and services down to components
const contextProvider = new ContextProvider(document.body);
new ContextRoot().attach(document.body);

// tell apps that Adobe is loaded/ready to listen for events
// remove 3000 to wait indefinitely
// waitFor(() => Object.prototype.hasOwnProperty.call(window, '_satellite'), 3000)
//   .then(() => contextProvider.provide(contexts.analyticsReady, true))

contextProvider.provide(contexts.apiContext, environment.api);
contextProvider.provide(contexts.i18nContext, initI18n(environment.i18n));

const campaignsService = new CampaignsService(environment.api.campaigns, environment.logger);
campaignsService.getCampaignsInfo().then((campaignInfo) => {
  contextProvider.provide(contexts.dynamicPhoneNumberContext, campaignInfo['campaignPhone-cipublic']);
  contextProvider.provide(contexts.dynamicLinksContext, campaignInfo);

  // TODO: Think about reworking this
  queryShadowRoot(document.body).forEach((link) => {
    const newLinkHref = updateDynamicLinks((link as HTMLAnchorElement).href, campaignInfo);
    if (newLinkHref && newLinkHref.length) {
      (link as HTMLAnchorElement).href = newLinkHref;
    }
  });
});
setupClickTracking(createImpression, environment.logger);
